import { FieldErrors } from 'react-hook-form'
import { ErrorSummaryStyled } from '../onboardingStyles'
import { ICoachProfileFormValues } from '../types'

// Fields surfaced in the summary, in form order, mapped to the DOM id to scroll to.
const ERROR_FIELDS: { name: keyof ICoachProfileFormValues; label: string; targetId: string }[] = [
  { name: 'firstName', label: 'First name', targetId: 'firstName' },
  { name: 'lastName', label: 'Last name', targetId: 'lastName' },
  { name: 'gender', label: 'Gender', targetId: 'gender' },
  { name: 'stateOfResidence', label: 'State of residence', targetId: 'stateOfResidence' },
  { name: 'credentials', label: 'Credentials', targetId: 'credentials' },
  { name: 'cdrCnsNumber', label: 'CDR/CNS number', targetId: 'cdrCnsNumber' },
  { name: 'cdrCnsExpirationDate', label: 'Expiration date', targetId: 'cdrCnsExpirationDate' },
  { name: 'cdrCnsCard', label: 'License card', targetId: 'cdrCnsCard-input' },
  { name: 'photo', label: 'Headshot', targetId: 'photo-input' },
  { name: 'specialties', label: 'Specialties', targetId: 'section-specialties' },
  { name: 'bio', label: 'Bio', targetId: 'bio' }
]

interface IErrorSummary {
  errors: FieldErrors<ICoachProfileFormValues>
  show: boolean
}

export const ErrorSummary = ({ errors, show }: IErrorSummary) => {
  const entries = ERROR_FIELDS.filter((field) => errors[field.name])
  if (!show || entries.length === 0) return null

  const jumpTo = (targetId: string) =>
    document.getElementById(targetId)?.scrollIntoView({ behavior: 'smooth', block: 'center' })

  return (
    <ErrorSummaryStyled role="alert">
      <strong>Please fix the items below before submitting.</strong>
      <ul>
        {entries.map((field) => (
          <li key={field.name}>
            <a
              href={`#${field.targetId}`}
              onClick={(event) => {
                event.preventDefault()
                jumpTo(field.targetId)
              }}
            >
              {field.label}
            </a>{' '}
            — {errors[field.name]?.message}
          </li>
        ))}
      </ul>
    </ErrorSummaryStyled>
  )
}
